import AcquisitionsAPI from "@/api/acquisitions";
import { SelectBox, TextInput } from "@monolith-forensics/monolith-ui";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";

interface FormatSelectorProps {
  defaultValue?: string;
  onChange?: (value: string) => void;
  error?: string;
  openOnFocus?: boolean;
}

type Format = {
  format: string;
  format_id: number;
};

const FormatSelector: FC<FormatSelectorProps> = ({
  defaultValue,
  onChange,
  error,
  openOnFocus = false,
}) => {
  const { data: formatList, isLoading } = useQuery<Format[]>({
    queryKey: ["acquisition:formats:list"],
    queryFn: () => AcquisitionsAPI.getFormats(),
  });

  const options =
    formatList?.map((format) => ({
      label: format?.format,
      value: format?.format,
    })) || [];

  return (
    <>
      <SelectBox
        defaultValue={defaultValue}
        size="sm"
        variant="outlined"
        label="Format"
        placeholder="Select..."
        description="This is the format that was used for the acquisition."
        onChange={onChange}
        data={options}
        error={error}
        clearable={true}
        searchable={true}
        allowCustomValue={true}
        openOnFocus={openOnFocus}
      />
    </>
  );
};

export default FormatSelector;
